export default __webpack_public_path__ + "static/Cognizant_Softvision_logo-dac6ab144eb3ab00d679630437587680.svg";